import { discoverConstants as dc } from 'srcReact/DiscoverPage'
import { groupHomeConstants } from 'srcReact/GroupHomePage'

const initialState = {
  myMixrsLoading: false,
  myGroupsLoading: false,
  all: {
    myMixrsLoading: true,
    myMixrsLoaded: false,
    myGroupsLoading: true,
    myGroupsLoaded: false,
    stats: {
      total_mixrs: 0,
      total_groups: 0,
      total_all_mixrs: 0,
      total_all_groups: 0
    },
    mixr_list: [],
    group_list: []
  }
}

export function discover(state = initialState, action) {
  switch (action.type) {
    case dc.GET_DISCOVER_ALL_REQUEST:
      return {
        ...state,
        all: {
          ...state.all,
          myMixrsLoaded: false,
          myMixrsLoading: true,
          myGroupsLoaded: false,
          myGroupsLoading: true
        }
      }
    case dc.GET_DISCOVER_ALL_SUCCESS:
      return {
        ...state,
        all: {
          ...state.all,
          stats: {
            ...state.all.stats,
            ...action.data.stats
          },
          mixr_list: action.data.mixr_list,
          group_list: action.data.group_list,
          moderation_info: action.data.moderation_info,
          myMixrsLoaded: true,
          myMixrsLoading: false,
          myGroupsLoaded: true,
          myGroupsLoading: false
        }
      }
    case dc.GET_DISCOVER_ALL_FAILURE:
      return {
        ...state,
        all: {
          ...state.all,
          myMixrsLoaded: true,
          myMixrsLoading: false,
          myGroupsLoaded: true,
          myGroupsLoading: false
        }
      }
    case dc.GET_DISCOVER_MIXR_LIST_REQUEST:
      return {
        ...state,
        all: {
          ...state.all,
          myMixrsLoading: true,
          myMixrsLoaded: false
        }
      }
    case dc.GET_DISCOVER_MIXR_LIST_SUCCESS:
      return {
        ...state,
        all: {
          ...state.all,
          mixr_list: action.data,
          myMixrsLoading: false,
          myMixrsLoaded: true
        }
      }
    case dc.GET_DISCOVER_MIXR_LIST_PAGINATION_REQUEST:
      return {
        ...state,
        myMixrsLoading: true
      }
    case dc.GET_DISCOVER_MIXR_LIST_PAGINATION_SUCCESS:
      // const nextMixrsIds = new Set(action.data.map((m) => m.id))
      return {
        ...state,
        all: {
          ...state.all,
          // mixr_list: [...state.all.mixr_list.filter((m) => !nextMixrsIds.has(m.id)), ...action.data].sort(
          //   (a, b) => new Date(a.event_utc_start_datetime) - new Date(b.event_utc_start_datetime)
          // )
          mixr_list: [...state.all.mixr_list, ...action.data]
        },
        myMixrsLoading: false
      }

    case dc.GET_DISCOVER_GROUP_LIST_REQUEST:
      return {
        ...state,
        all: {
          ...state.all,
          myGroupsLoading: true,
          myGroupsLoaded: false
        }
      }
    case dc.GET_DISCOVER_GROUP_LIST_SUCCESS:
      return {
        ...state,
        all: {
          ...state.all,
          group_list: action.data,
          myGroupsLoading: false,
          myGroupsLoaded: true
        }
      }
    case dc.GET_DISCOVER_GROUP_LIST_PAGINATION_REQUEST:
      return {
        ...state,
        myGroupsLoading: true
      }
    case dc.GET_DISCOVER_GROUP_LIST_PAGINATION_SUCCESS:
      // const nextGroupsIds = new Set(action.data.map((g) => g.group_id))
      return {
        ...state,
        all: {
          ...state.all,
          // group_list: [...state.all.group_list.filter((g) => !nextGroupsIds.has(g.group_id)), ...action.data]
          group_list: [...state.all.group_list, ...action.data]
        },
        myGroupsLoading: false
      }
    case groupHomeConstants.JOIN_GROUP_MEMBER_SUCCESS: {
      let updatedGroupList = state.all.group_list
      if (action.data.user_attending_status === 'joined') {
        updatedGroupList = updatedGroupList.filter((group) => group.group_id !== action.groupId)
      } else if (action.data.user_attending_status === 'pending') {
        updatedGroupList = updatedGroupList.map((group) => {
          if (group.group_id === action.groupId) {
            group.group_attending = 'pending'
            return group
          }
          return group
        })
      }
      return {
        ...state,
        all: {
          ...state.all,
          group_list: updatedGroupList
        }
      }
    }

    default:
      return state
  }
}
